import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";

import Header_Company from '../../Components/Header_Company';
import Register_Agent from '../../Components/CompanyDetails/Register_Agent';
import Register_Supervisor from '../../Components/CompanyDetails/Register_Supervisor';

const Register_Company_Emp = () => {
  const [activeTab, setActiveTab] = useState('supervisor'); // Default tab

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");

    if (!storedUserData) {
      Swal.fire("Error", "No user data found in sessionStorage.", "error");
    }
  }, []);

  return (
    <div className="container-fluid">
      <Header_Company />

      {/* Tabs */}
      <ul className="nav nav-tabs mt-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'Register_Supervisor' ? 'active' : ''}`}
            onClick={() => setActiveTab('Register_Supervisor')}
          >
            Register_Supervisor
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'Register_Agent' ? 'Register_Agent' : ''}`}
            onClick={() => setActiveTab('agent')}
          >
            Register_Agent
          </button>
        </li>
      </ul>

      {/* Tab Content */}
      <div className="tab-content mt-4">
        {activeTab === 'Register_Supervisor' && (
          <div className="tab-pane fade show active">
            <Register_Supervisor />
          </div>
        )}
        {activeTab === 'Register_Agent' && (
          <div className="tab-pane fade show active">
            <Register_Agent />
          </div>
        )}
      </div>
    </div>
  );
};

export default Register_Company_Emp;
